import Heading from "components/Heading/Heading";
import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import HIW1img from "images/HIW2-1.png";
import HIW2img from "images/HIW2-2.png";
import HIW3img from "images/HIW2-3.png";
import VectorImg from "images/VectorHIW.svg";
import usePropertyListModal from "hooks/usePropertyListModal";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionHowItWorkProps {
  className?: string;
  data?: {
    id: number;
    title: string;
    desc: string;
    img: string;
    imgDark?: string;
    onClk?: string;
  }[];
}

const DEMO_DATA: SectionHowItWorkProps["data"] = [
  {
    id: 1,
    img: HIW1img,
    title: "Избери своя имот",
    desc: "Подбрахме специално за теб хотели и имоти за пробно изживяване.",
    onClk: "browse",
  },
  {
    id: 2,
    img: HIW2img,
    title: "Пробвай преди да решиш",
    desc: "Наслади се на истински престой и открий дали мястото подхожда на твоя стил на живот.",
    onClk: "experience",
  },
  {
    id: 3,
    img: HIW3img,
    title: "Инвестирай с увереност",
    desc: "Когато почувстваш, че е твоето място, пристъпи към покупка или инвестиция без риск.",
    onClk: "invest",
  },
];

const SectionHowItWork: FC<SectionHowItWorkProps> = ({ className = "", data = DEMO_DATA }) => {
  const listProperty = usePropertyListModal();
  const navigate = useNavigate();
  return (
    <div className={`nc-SectionHowItWork  ${className}`} data-nc-id="SectionHowItWork">
      <Heading isCenter desc="TryBuy">
        Как работи
      </Heading>
      <div className="mt-20 relative grid md:grid-cols-3 gap-20">
        <img className="hidden md:block absolute inset-x-0 top-10" src={VectorImg} alt="" />
        {DEMO_DATA.map((item) => (
          <div key={item.id} className="relative flex flex-col items-center max-w-xs mx-auto">
            {item.imgDark ? (
              <>
                <NcImage
                  onClick={() => {
                    if (item.onClk === "list") {
                      listProperty.onOpen();
                    } else if (item.onClk === "become") {
                      navigate("/contacts");
                    } else {
                      navigate(
                        "/listings?state=&location=&lat=undefined&lng=undefined&minPrice=10000&maxPrice=10000000"
                      );
                    }
                  }}
                  containerClassName="dark:hidden block mb-8 max-w-[200px] mx-auto"
                  src={item.img}
                />
                <NcImage
                  onClick={() => {
                    if (item.onClk === "list") {
                      listProperty.onOpen();
                    } else if (item.onClk === "become") {
                      navigate("/contacts");
                    } else {
                      navigate(
                        "/listings?state=&location=&lat=undefined&lng=undefined&minPrice=10000&maxPrice=10000000"
                      );
                    }
                  }}
                  containerClassName="hidden dark:block mb-8 max-w-[200px] mx-auto"
                  src={item.imgDark}
                />
              </>
            ) : item.onClk ? (
              <NcImage
                onClick={() => {
                  if (item.onClk === "list") {
                    listProperty.onOpen();
                  } else if (item.onClk === "become") {
                    navigate("/contacts");
                  } else {
                    navigate(
                      "/listings?state=&location=&lat=undefined&lng=undefined&minPrice=10000&maxPrice=10000000"
                    );
                  }
                }}
                containerClassName="mb-8 max-w-[200px] mx-auto cursor-pointer"
                src={item.img}
              />
            ) : (
              <NcImage
                onClick={() => {
                  if (item.onClk === "list") {
                    listProperty.onOpen();
                  } else if (item.onClk === "become") {
                    navigate("/contacts");
                  } else {
                    navigate(
                      "/listings?state=&location=&lat=undefined&lng=undefined&minPrice=10000&maxPrice=10000000"
                    );
                  }
                }}
                containerClassName="mb-8 max-w-[200px] mx-auto"
                src={item.img}
              />
            )}
            <div className="text-center mt-auto">
              <ButtonPrimary
                className={`${item.onClk === "" ? "mb-6" : ""}`}
                onClick={() => {
                  if (item.onClk === "list") {
                    listProperty.onOpen();
                  } else if (item.onClk === "become") {
                    navigate("/contacts");
                  } else {
                    navigate(
                      "/listings?state=&location=&lat=undefined&lng=undefined&minPrice=10000&maxPrice=10000000"
                    );
                  }
                }}
              >
                {item.title}
              </ButtonPrimary>
              <span className="block mt-5 text-neutral-500 dark:text-neutral-400">{item.desc}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionHowItWork;
